async function getJson(url) {
  const res = await fetch(url, { credentials: 'same-origin' });
  const data = await res.json();
  if (!data.ok) {
    throw new Error(data.error || 'Something went wrong. Please try again.');
  }
  return data;
}

export function fetchCalendar(slug, from, to) {
  return getJson('/api/booking.php?action=calendar' +
    '&slug=' + encodeURIComponent(slug) +
    '&from=' + encodeURIComponent(from) +
    '&to=' + encodeURIComponent(to));
}

export function fetchCalendarAll(from, to) {
  return getJson('/api/booking.php?action=calendar-all' +
    '&from=' + encodeURIComponent(from) +
    '&to=' + encodeURIComponent(to));
}

export function fetchAvailability(inDate, outDate, adults, children) {
  return getJson('/api/booking.php?action=availability' +
    '&in=' + encodeURIComponent(inDate) +
    '&out=' + encodeURIComponent(outDate) +
    '&a=' + encodeURIComponent(adults) +
    '&c=' + encodeURIComponent(children));
}
